module.exports = __webpack_public_path__ + "assets/wenjian.f3ad0c0114bc6ac5e31318689b8b3a02.png";